import { Component } from '@angular/core';
import { RdsModule } from '@rabobank/rds-angular';

@Component({
  selector: 'app-footer',
  imports: [RdsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {}
